module.exports = __webpack_public_path__ + "img/step-three-icon.89c3b3d5.jpg";